import IconCopy from "app/components/Icon/components/IconCopy/IconCopy";
import { DepositDetailsType } from "app/types/cryptoType";
import { UserType } from "app/types/userType";
import { TransactionDetailsStatus } from "app/utils/const";
import React, { MouseEventHandler } from "react";
import Countdown from "react-countdown";
import { FormattedMessage } from "react-intl";

import "./CryptoFundingQuote.scss";

type Props = {
  depositDetails: DepositDetailsType;
  user: UserType;
  copyAmountInfo: MouseEventHandler;
};

// Extracted following from CryptoFundingCompleteDeposit to make this component to simplify CryptoFundingCompleteDeposit
const CryptoFundingQuote: React.FC<Props> = ({
  depositDetails,
  user,
  copyAmountInfo,
}) => {
  const timeRenderer = ({
    minutes,
    seconds,
    completed,
  }: {
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      return <FormattedMessage id="cashier-expired" />;
    } else {
      return (
        <span>
          {minutes < 10 ? "0" : ""}
          {minutes}:{seconds < 10 ? "0" : ""}
          {seconds}
        </span>
      );
    }
  };

  return (
    <div className="crypto-quote__quote-info">
      <div className="crypto-quote__title">
        <FormattedMessage id="cashier-crypto-quote" />
      </div>
      <div className="crypto-quote__amount">
        <span>{`${depositDetails.amountSending} ${user.currencyCode} = ${
          depositDetails.receiveQuantity
        } 
        ${depositDetails.selectedCoin.replace(/_/g, "-")}`}</span>

        <IconCopy onClick={copyAmountInfo} />
      </div>
      {depositDetails.expireTime &&
        depositDetails.status === TransactionDetailsStatus.NEW && (
          <div className="crypto-quote__quote-info__expiry-message">
            <FormattedMessage id="cashier-expiry-message-start" />
            <Countdown
              date={depositDetails.expireTime}
              renderer={timeRenderer}
              zeroPadTime={2}
            />
            <FormattedMessage id="cashier-expiry-message-end" />
          </div>
        )}
      <FormattedMessage id="cashier-crypto-exchange-fees" />
    </div>
  );
};

export default CryptoFundingQuote;
